<script>
    import DialogBody from "./components/dialog-body.vue";
    import DialogActionbar from "./components/dialog-actionbar.vue";
    import DialogHeader from "./components/dialog-header.vue";
    import DialogBase from "./components/dialog-base.vue";
    import ConfirmDialogBody from "./confirm-dialog-body.vue";

    export default {
        name: "confirm-dialog",
        components: {ConfirmDialogBody, DialogHeader, DialogActionbar, DialogBody, DialogBase },
        props: {
            showDialog: {
                type: Boolean
            },
            title: {
                type: String,
                default: Lang.langGet('Confirm delete')
            },
            message: {
                type: String
            },
            confirmMsg: {
                type: String
            },
            confirmText: {
                type: String,
                default: Lang.langGet('Yes')
            },
            abortText: {
                type: String,
                default: Lang.langGet('No')
            },
            showTextIcon: {
                type: Boolean,
                default: false
            },
            textIconType: {
                Type: String,
                default: 'fal fa-triangle-exclamation'
            },
            noIcons: {
                type: Boolean
            }
        },
        methods: {
            handleCancel() {
                this.$emit('cancel');
            },
            handleConfirm() {
                this.$emit('confirm');
            }
        }
    }
</script>

<template>
    <dialog-base
        :maxWidth="600"
        :showDialog="showDialog"
        @close="handleCancel"
    >
        <dialog-header
            :title="title"
            @close="handleCancel"
        />
        <dialog-body>
            <confirm-dialog-body
                :message="message"
                :confirmMsg="confirmMsg"
                :showTextIcon="showTextIcon"
                :textIconType="textIconType"
            />
        </dialog-body>
        <dialog-actionbar
            :noIcons="noIcons"
            :confirmText="confirmText"
            :abortText="abortText"
            :confirmIcon="'trash'"
            @close="handleCancel"
            @save="handleConfirm"
        >
        </dialog-actionbar>
    </dialog-base>
</template>
